
export const formatToCurrency = (amount) => {
  if(amount !== undefined || amount !== ""){
    let amountFloat = parseFloat(amount)
    return  amountFloat.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
  }else{
    return amount
  }
}

export const roundAmount = balance => {
  const amount1 = process.env.REACT_APP_FACTURA_TELCEL_AMOUNT_1;
  const amount2 = process.env.REACT_APP_FACTURA_TELCEL_AMOUNT_2;
  const increacePercentage = process.env.REACT_APP_FACTURA_TELCEL_INCREACE_PERCENTAGE;
  if (balance <= amount1) {
    return amount2;
  } else {
    const balanceWithIncreacedPercentage = balance * (1 + increacePercentage / 100);
    return Math.floor(balanceWithIncreacedPercentage);
  }
}